import { render, staticRenderFns } from "./BasicLayoutHeader.vue?vue&type=template&id=50db51d6&scoped=true&"
import script from "./BasicLayoutHeader.vue?vue&type=script&lang=js&"
export * from "./BasicLayoutHeader.vue?vue&type=script&lang=js&"
import style0 from "./BasicLayoutHeader.vue?vue&type=style&index=0&id=50db51d6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50db51d6",
  null
  
)

export default component.exports